import styled from 'styled-components'

export const AttributeContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-right: auto;
`

export const ComponentName = styled.div`
  flex: 1;
  min-width: 0;
  padding-right: 12px;
`
